// ======================================================================
// File Name       : ServiceRecordAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import { commonCallApi, downLoadFile } from '../../utils/ApiUtils';
import * as httpRequests from '../httpRequests/service';
import * as ActionTypes from '../../constants/actionTypes/serviceRecord';
import * as serviceRecordActionCreators from '../actionCreators/serviceRecord';
import { DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM } from '../../constants/index';
import { openModal } from '../ModalAction';
import * as ModalIds from '../../constants/ModalIds';

export function getRecordList(params, pathOptions) {
  return dispatch => httpRequests.getRecordList(params, pathOptions).then((resdata) => {
    if (params.selectTargetData === SELECT_TARGET_DATA.CSV) {
      if (resdata.csvfileUrl) {
        const link = document.createElement('a');
        link.href = resdata.csvfileUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      dispatch(receiveRecordList(resdata, pathOptions.url));
    }
  });
}
function receiveRecordList(resdata, url) {
  return serviceRecordActionCreators.receiveRecordList(resdata, url);
}

export function reInitializeForm(newEnterpriseCd, newServiceCd) {
  return {
    type: ActionTypes.REINITIALIZE_FORM,
    newEnterpriseCd,
    newServiceCd,
  };
}

export function getServiceList(searchInfo) {
  return (dispatch) => {
    return httpRequests.getServiceList(searchInfo)
      .then((camelizeJson) => {
        return dispatch(serviceRecordActionCreators.receiveServiceList(camelizeJson));
      });
  };
}

export function saveSystemUsageMonths(systemUsageMonths, callBack) {
  return (dispatch) => {
    dispatch(serviceRecordActionCreators.saveSystemUsageMonths(systemUsageMonths));
    callBack();
  };
}

export function downloadFormRecord(downloadInfo) {
  return (dispatch) => {
    httpRequests.systemDownloadForm(downloadInfo).then((resdata) => {
      downloadFormResponse(resdata);
    });
  };
}

function downloadFormResponse(resdata) {
  if (resdata && resdata.chargeCsvList && resdata.chargeCsvList.length) {
    const listLength = resdata.chargeCsvList.length;
    let duration = 0;
    let url;
    const waitTime = 1000; // Wait 1s
    for (let i = 0; i < listLength; i++) {
      setTimeout(() => {
        url = resdata.chargeCsvList[i];
        // IE
        if (window.navigator.msSaveOrOpenBlob) {
          downLoadFile(url).then((blob) => {
            const blobObj = new Blob([blob], { type: 'text/plain' });
            const fileName = url.substring(url.lastIndexOf('/') + 1, url.indexOf('?'));
            window.navigator.msSaveOrOpenBlob(blobObj, fileName);
          });
        } else {
          const link = document.createElement('a');
          link.href = url;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }, duration);
      duration += waitTime;
    }
  }
}

export function getMonthList(months) {
  return (dispatch) => {
    dispatch(getMonths(months));
  };
}

export function getDownloadFormMonthList(months) {
  return (dispatch) => {
    dispatch(getDownloadFormMonths(months));
  };
}

function getMonths(list) {
  return {
    type: ActionTypes.SERVICE_MONTH_LIST,
    monthList: list,
  };
}

function getDownloadFormMonths(list) {
  return {
    type: ActionTypes.SERVICE_DOWNLOAD_FORM_MONTH_LIST,
    downloadFormMonthList: list,
  };
}
